import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { useMutation } from '@/proxy/react-query'

export const UPDATE_POC_INFO = gql`
  mutation updatePocInfo($input: UpdatePocInfoInput!) {
    updatePocInfo(input: $input) {
      success
      errors {
        category
        message
        target
        key
        args
      }
    }
  }
`

export const useUpdatePocInfo = () =>
  useMutation({
    mutationFn: variables => client.request(UPDATE_POC_INFO, variables),
  })
